export default __webpack_public_path__ + "static/media/PDFReport-Interior-Pg1.12b7e8c0.png";